import { RouterProvider } from 'react-router-dom'
import { Provider } from 'react-redux'
import { store } from './app/store'
import { appRouter } from './routes'
import { I18nProvider } from '@lib/i18n/I18nProvider'
import { SoftwareUpdateBanner } from '@/components/SoftwareUpdateBanner'
import '@/components/SoftwareUpdateBanner/softwareUpdateBanner.css'

function App() {
  return (
    <I18nProvider>
      <Provider store={store}>
        <SoftwareUpdateBanner />
        <RouterProvider router={appRouter} />
      </Provider>
    </I18nProvider>
  )
}

export default App
